'use client'

import { ChevronDown } from 'lucide-react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { usePulseInstallers } from './usePulseInstallers'
import type { PulsePlatform } from '@/lib/tracker/releases'

const PLATFORMS: { id: PulsePlatform; name: string; detail: string }[] = [
  { id: 'mac', name: 'macOS', detail: 'Apple silicon and Intel' },
  { id: 'windows', name: 'Windows', detail: 'Windows x64' },
]

export default function DownloadPulseMenu() {
  const { installers, current } = usePulseInstallers()
  const available = [installers.mac, installers.windows].find(value => value && value !== 'unavailable')
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="btn-primary absolute right-4 top-4 pr-3">
        Download Pulse
        <ChevronDown className="size-4" aria-hidden />
      </DropdownMenuTrigger>
      {/* The portal needs its own light tokens outside the login page's scope. */}
      <DropdownMenuContent align="end" className="halo-light w-72">
        <DropdownMenuLabel className="text-xs font-medium text-halo-muted">
          {available && available !== 'unavailable' ? `HALO Pulse ${available.version} for` : 'HALO Pulse for'}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {PLATFORMS.map(platform => {
          const installer = installers[platform.id]
          const body = <>
            <span className="flex min-w-0 flex-1 flex-col">
              <span className="font-medium">{platform.name}</span>
              <span className="text-xs text-halo-muted">
                {installer === null ? 'Finding the latest version…'
                  : installer === 'unavailable' ? 'Installer unavailable. Try again later.' : platform.detail}
              </span>
            </span>
            {current === platform.id && <span className="mt-0.5 rounded-xs bg-halo-inset px-1.5 text-xs leading-[18px] text-halo-secondary">This computer</span>}
          </>
          return installer && installer !== 'unavailable'
            ? <DropdownMenuItem key={platform.id} asChild className="items-start py-2"><a href={installer.url}>{body}</a></DropdownMenuItem>
            : <DropdownMenuItem key={platform.id} disabled className="items-start py-2">{body}</DropdownMenuItem>
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
